import { DataRecord, RecordKind } from './record.js';
import { SchemaTypeRef } from './schema.js';
import { ExpressionConstraint } from './constraint.js';
import { FilterRegistry } from './services/FilterRegistry.js';


class Product extends DataRecord {
  public model: { [key: string]: any };
  public constraints: ExpressionConstraint[] = [];
  filters: FilterRegistry;

  constructor(_class: SchemaTypeRef,
              model: {},
              constraints: ExpressionConstraint[] = [],
              id?: string,
              filters: FilterRegistry             = null) {
    super(_class, RecordKind.Product, id);
    this.model = model;
    this.filters = filters;
    this.constraints = constraints;
  }
}

class ProductGroup extends DataRecord {
  public model: any = {};
  public children: Array<Product | ProductGroup>;

  constructor(_class: SchemaTypeRef, children: Array<Product | ProductGroup>, model: any, id?: string) {
    super(_class, RecordKind.ProductGroup, id);
    this.children = children;
    this.model = model;
  }
}

export {
  Product,
  ProductGroup
}
